/**
 * 選択中の船舶情報を管理
 */
import state from './moduleEnterpriseMapVesselSelectedState.js'
import mutations from './moduleEnterpriseMapVesselSelectedMutations.js'
import actions from './moduleEnterpriseMapVesselSelectedActions.js'
import getters from './moduleEnterpriseMapVesselSelectedGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
